import DataTable from 'react-data-table-component';
import CustomLoader from './custom-loader';

const CaseManagerChangeLogTable = ({ changeLog, progressPending }) => {
    /**
     * setup change log columns
     */
    const columns = [
        {
            name: <span className="custom-table-header" title="EVENT TYPE">EVENT TYPE</span>,
            selector: row => row.eventType,
            sortable: true,
        },
        {
            id: 'eventDate',
            name: <span className="custom-table-header" title="EVENT DATE">EVENT DATE</span>,
            selector: row => row.eventDate,
            cell: row => <span>{new Date(row.eventDate.endsWith('Z') ? row.eventDate : row.eventDate+"Z").toLocaleString()}</span>,
            sortable: true,
        },
        {
            name: <span className="custom-table-header" title="TRIGGERED BY">TRIGGERED BY</span>,
            selector: row => row.triggeredByPortal.firstName + " " + row.triggeredByPortal.lastName,
            sortable: true,
        },
    ];

    const paginationComponentOptions = {
        noRowsPerPage: true,
    };


    return (
        <div className="custom-table">
            <DataTable
                pagination
                paginationComponentOptions={paginationComponentOptions}
                columns={columns}
                data={changeLog}
                progressPending={progressPending}
                progressComponent={<CustomLoader />}
                defaultSortFieldId="eventDate"
                defaultSortAsc={false}
            />
        </div>
    );
};

export default CaseManagerChangeLogTable;